// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + "0e52c4b98a0a86ca3c3d" + "." + "main" + ".css";
};